import { render } from "./WebPage.vue?vue&type=template&id=e436eb8c&scoped=true"
import script from "./WebPage.vue?vue&type=script&lang=js"
export * from "./WebPage.vue?vue&type=script&lang=js"

import "./WebPage.vue?vue&type=style&index=0&id=e436eb8c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e436eb8c"]])

export default __exports__